/* The in-flight state (my-work.md MA5 state 0 / MA16), ported from
   renderLoading (app.ts ~5177): a skeleton in the content's silhouette so the
   answer lands without a reflow, aria-busy + a visually-hidden line, and NO
   placeholder text that could be misread as data. The announcement is spoken
   from the persistent #live region, never from this replaced node. */
import { useEffect, type JSX } from "react";
import { ViewFrame } from "./ViewFrame";
import { announce } from "./live";

export function Loading({ what }: { what: string }): JSX.Element {
  /* announce on mount; clear on unmount, so the accessibility tree stops
     asserting "Loading…" the moment the section answers (app.ts render clears
     #live at the top of every paint) */
  useEffect(() => {
    announce(`Loading ${what}…`);
    return () => announce("");
  }, [what]);
  return (
    <ViewFrame
      banner={
        <div className="banner">
          <b>Loading {what}…</b>
          <span>Reading the record — nothing is claimed about it yet.</span>
        </div>
      }
    >
      <section className="card skeleton-card" aria-busy="true">
        <span className="sr-only">Loading {what}…</span>
        <div className="skeleton skeleton-line wide" aria-hidden="true" />
        <div className="skeleton skeleton-line" aria-hidden="true" />
        <div className="skeleton skeleton-line narrow" aria-hidden="true" />
      </section>
    </ViewFrame>
  );
}
